import { CdkPortal } from '@angular/cdk/portal';
import { EventEmitter, Signal } from '@angular/core';
import { TabTitleDirective } from './tab-title/tab-title.directive';

export abstract class Tab {
  abstract title?: string | null | undefined;
  abstract icon?: Signal<string | null | undefined>;
  abstract templateTitle?: TabTitleDirective;
  abstract content?: CdkPortal;
  abstract class?: Signal<string | null>;
  abstract activate: EventEmitter<any>;
  abstract deactivate: EventEmitter<any>;
  abstract badge?: Signal<number | null | undefined>;
  abstract badgeClass?: Signal<string | null | undefined>;
}
